import { lazyLoad } from 'utils/loadable';
import { Navigate } from 'react-router-dom';
import { AiAgentSubMenuRoutes } from 'modules/AiAgents/aiAgentsConfigPages';

const AiAgentPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAgentPage', webpackPrefetch: true */ './index'
  ),
);

const AiAssistantFunctionPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantFunctionPage', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantFunctions'
  ),
);

const AiAssistantPages = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantPages', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantPages'
  ),
);

const AiAssistantMenuPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantMenuPage', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantMenu'
  ),
);
const AiAssistantThemePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantThemePage', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantTheme'
  ),
);

const AccountAppearancePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AccountAppearancePage', webpackPrefetch: true */ '../Settings/components/Account/Appearences'
  ),
);

const CredentialsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'Credentials', webpackPrefetch: true */ '../Settings/components/Credentials'
  ),
);

const TrainAiPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'TrainAi', webpackPrefetch: true */ '../AiTraining/index'
  ),
);

const LogsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LogsPage', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantLogs'
  ),
);

const ListMenuPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ListMenuPage', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantListMenu'
  ),
);

const AiAssistantServicesMenuPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantServicesMenu', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantServicesMenu'
  ),
);

const ShareLinkSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ShareLinkSettingsPage', webpackPrefetch: true */ '../Settings/components/ShareLinkSettings/index'
  ),
);

const LanguageSettingsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LanguageSettingsPage', webpackPrefetch: true */ '../Settings/components/Support/SupportLanguageSettings'
  ),
);

const IntroMessagesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'IntroMessagesPage', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantIntroMessages'
  ),
);

const IndustryDataPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'IndustryDataPage', webpackPrefetch: true */ '../Settings/components/IndustryData/index'
  ),
);

const AiAssistantFeedbackPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantFeedbackPage', webpackPrefetch: true */ '../Settings/components/AiAssistant/AiAssistantFeedback'
  ),
);

const AiAssistantMediaTrainingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AiAssistantMediaTrainingPage', webpackPrefetch: true */ '../Settings/components/TrainAi/MediaTraining'
  ),
);

export const aiAgentMenuRoutes = allowAdminRoutes => [
  ...(allowAdminRoutes
    ? [
        {
          component: AiAssistantFunctionPage,
          title: 'Functions',
          path: AiAgentSubMenuRoutes.AI_ASSISTANT_FUNCTIONS,
        },
        {
          component: AiAssistantPages,
          title: 'Pages',
          path: AiAgentSubMenuRoutes.AI_ASSISTANT_PAGES,
        },
        {
          component: AiAssistantMenuPage,
          title: 'Chat Menus',
          path: AiAgentSubMenuRoutes.AI_ASSISTANT_MENU,
        },
        {
          component: AiAssistantThemePage,
          title: 'Theme',
          path: AiAgentSubMenuRoutes.AI_ASSISTANT_THEME,
        },
        {
          component: AccountAppearancePage,
          title: 'Appearance',
          path: AiAgentSubMenuRoutes.ACCOUNT_APPEARANCE,
        },
        {
          component: CredentialsPage,
          title: 'Credentials',
          path: AiAgentSubMenuRoutes.APP_CREDENTIAL,
        },
        {
          component: TrainAiPage,
          title: 'Passive Data',
          path: AiAgentSubMenuRoutes.TRAIN_AI,
        },
        {
          component: LogsPage,
          title: 'Logs',
          path: AiAgentSubMenuRoutes.AI_ASSISTANT_LOGS,
        },
        {
          component: ListMenuPage,
          title: 'List Menu',
          path: AiAgentSubMenuRoutes.LIST_MENU,
        },
        {
          component: AiAssistantServicesMenuPage,
          title: 'Services Menu',
          path: AiAgentSubMenuRoutes.AI_ASSISTANT_SERVICES_MENU,
        },
        {
          component: ShareLinkSettingsPage,
          title: 'Share',
          path: AiAgentSubMenuRoutes.SHARE_LINK_SETTINGS,
        },
        {
          component: LanguageSettingsPage,
          title: 'Language Settings',
          path: AiAgentSubMenuRoutes.LANGUAGE_SETTINGS,
        },
        {
          component: IntroMessagesPage,
          title: 'Intro Messages',
          path: AiAgentSubMenuRoutes.INTRO_MESSAGES,
        },
        {
          component: IndustryDataPage,
          title: 'Industry Data',
          path: AiAgentSubMenuRoutes.INDUSTRY_DATA,
        },
        {
          component: AiAssistantFeedbackPage,
          title: 'Feedback',
          path: AiAgentSubMenuRoutes.FEEDBACK,
        },
        {
          component: AiAssistantMediaTrainingPage,
          title: 'Image Training',
          path: AiAgentSubMenuRoutes.IMAGE_TRAINING,
          isImage: true,
        },
        {
          component: AiAssistantMediaTrainingPage,
          title: 'Video Training',
          path: AiAgentSubMenuRoutes.VIDEO_TRAINING,
          isImage: false,
        },
      ]
    : []),
];

// routes declaration
export const aiAgentRoutes = [
  {
    component: Navigate,
    path: '/ai-agent',

    replace: true,
    to: '/ai-agent' + AiAgentSubMenuRoutes.DEFAULT,
    toAdmin: '/ai-agent' + AiAgentSubMenuRoutes.DEFAULT,
    needsAuth: true,
  },
  {
    component: AiAgentPage,
    title: 'Ai-Agent',
    path: '/ai-agent/*',
    needsAuth: true,
  },
];
